exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-nav-container[data-v-206c94fc]{margin-top:-10px}.banner[data-v-206c94fc]{background-color:#06bafc;height:60px;color:#fff;margin-right:-25px;margin-left:-25px;padding-bottom:10px;padding-top:10px;padding-left:40px;margin-top:0}.form-group label[data-v-206c94fc]{margin:inherit}.aux-sidebar[data-v-206c94fc]{color:#fff;display:none}@media (max-width:720px){.list-container[data-v-206c94fc]{color:#fff}.list-container .row .col-sm-9[data-v-206c94fc]{display:none}.detail-title[data-v-206c94fc]{color:#fff;height:52px;line-height:1;margin-bottom:0;padding-left:70px;padding-top:10px}.detail-title.detail-title[data-v-206c94fc]{background-color:#04bafc}.aux-sidebar[data-v-206c94fc]{display:block;position:absolute;top:10px;left:31px;font-size:150%}}.form-group[data-v-206c94fc]{min-height:45vh}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-206c94fc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/report/ReportNameWizard.vue
// module id = 862
// module chunks = 0